import React, { useEffect, useState } from 'react';
import { withTranslation } from 'react-i18next';
import { domainName, portal_config } from '../../../portal.config';
import ModalConfirm from '../../components/ModalConfirm';
import { getCurrency } from '../../utils/common';
import crmservices from '../../wsclient/'
import ModalAlert from '../../components/ModalAlert';
import AccountAnalysisView from './AccountAnalysisView';
import { formatDateToDDMMYYYY, formatPeriodDate, getCurrencySymbol, getPeriodDate, statementPeriodOption } from '../../utils/util';
import moment from 'moment';
import { paths } from '../../../portal.router.config';

const PAGE_SIZE = 20;

function AccountAnalysisController(props) {
    const { t, classes } = props;
    const [showLoading, setShowLoading] = useState({});
    const [accountFinance, setAccountFinance] = useState({});
    const [wallet, setWallet] = useState({});
    const [confirm, setConfirm] = useState({});
    const [invoices, setInvoices] = useState([]);
    const [hasMore, setHasMore] = useState(true);
    const [showLoadMore, onShowLoadMore] = useState(false);
    const [error, setError] = useState({});
    const [contact, setContact] = useState(null);
    const [paging, setPaging] = useState(null);

    //filter
    const [listPeriods, setListPeriods] = useState([
        {
            value: statementPeriodOption.THIS_MONTH,
            label: 'This Month'
        },
        {
            value: statementPeriodOption.LAST_MONTH,
            label: 'Last Month'
        },
        {
            value: statementPeriodOption.THIS_YEAR,
            label: 'This Year'
        },
        {
            value: statementPeriodOption.LAST_YEAR,
            label: 'Last Year'
        },
        {
            value: statementPeriodOption.SPECIFIC_PERIOD,
            label: 'Specific Period'
        },
    ]);
    const [periodSeleted, setPeriodSeleted] = useState(statementPeriodOption.THIS_MONTH);
    const [params, setParams] = useState({
        from_date: formatPeriodDate(getPeriodDate('START_OF_' + statementPeriodOption.THIS_MONTH)),
        to_date: formatPeriodDate(getPeriodDate('END_OF_' + statementPeriodOption.THIS_MONTH)),
        // transaction_type: 'INVOICE',
        size: PAGE_SIZE,
    });
    const [specificPeriod, setSecificPeriod] = useState({
        from_date: formatDateToDDMMYYYY(getPeriodDate('START_OF_' + statementPeriodOption.THIS_MONTH)),
        to_date: formatDateToDDMMYYYY(getPeriodDate('END_OF_' + statementPeriodOption.THIS_MONTH)),
    });

    const [showTransactionDetail, setShowTransactionDetail] = useState(false);
    const [transactionDetail, setTransactionDetail] = useState(null);

    const [currency, setCurrency] = useState(getCurrency() ? getCurrency() : portal_config.default_currency);

    useEffect(() => {
        onLoad();
    }, []);

    const onLoad = async () => {
        setShowLoading(true);
        await onLoadWallet();
        await onLoadAccountJournals();
        await onLoadContact();
        setShowLoading(false);
    }

    const onLoadWallet = async () => {
        try {
            let result = await crmservices.account.getWalletInfo();
            console.log("AAAAAA load wallet:",result);
            if (result.code === 'OK') {
                setAccountFinance(result.data);
                setWallet(result.data.wallet);
                if(result.data && result.data.currency_code && result.data.currency_code){
                    setCurrency(getCurrencySymbol(result.data.currency_code));
                }
            }
        } catch (error) {
            console.log("load contact error:", error);
        }
    }

    const onLoadContact = async () => {
        try {
            var result = await crmservices.contacts.getContact();
            if (result.code === 'OK') {
                setContact(result.data)
            }
        } catch (error) {
            console.log("load contact error:", error);
        }
    }

    const handleLoadMore = async() => {
        let page = paging.page+1
        let newParams = {
            ...params,
            page: page,
        };
        setPaging(prevState =>({
            ...prevState,
            page: page
        }));
        setParams(newParams);
        onShowLoadMore(true);
        try {
            // let result = await crmservices.account.getAccountJournals(newParams);
            await onLoadAccountJournals(newParams, true);
            // console.log('handleLoadMore transactions result=',result)
            // if (result.code == 'OK') {
            //     setInvoices([...invoices,...result.data.content]);                
            //     if ( result.data.paging && result.data.paging.size < 10){
            //         setHasMore(false);
            //     }
            // }
        } catch (error) {
            console.log(" handleLoadMore getAccountJournals transactions error:", error);
        }
        onShowLoadMore(false);
    }

    const showAlert = (message) => {
        setShowLoading(false);
        setError({
            showAlert: true,
            message: message,
        });
    }

    const onCloseAlert = () => {
        setShowLoading(false);
        setError({
            showAlert: false,
            message: '',
        });
    }

    const onLoadAccountJournals = async (newParams, loadMore) => {
        try {
            let result = await crmservices.account.getAccountJournals(newParams ? newParams : params);
            console.log("AAAAAA load getAccountJournals:", result);
            if (result.code === 'OK') {
                if(loadMore)  setInvoices(invoices.concat(result.data.content))
                else setInvoices(result.data.content);
                setPaging(result.data.paging);
                if ( result.data.paging && result.data.paging.size < PAGE_SIZE){
                    setHasMore(false);
                }else setHasMore(true);
            }
        } catch (error) {
            console.log("load getAccountJournals error:", error);
        }
    }

    const onClickDetail = async (invoice) => {
        setShowLoading(true);
        try {
            let result = await crmservices.account.getJournal(invoice.id);
            console.log("AAAAAA load onClickDetail:", result);
            if (result.code === 'OK') {
                setTransactionDetail(result.data);
                setShowTransactionDetail(true);
            }
        } catch (error) {
            console.log("load onClickDetail error:", error);
        }
        setShowLoading(false);
    }
    
    const onFilter = async (values) => {
        setShowLoading(true);
        const { from_date, to_date } = values;
        let newParams = {...params};
        setParams(newParams);
        if (periodSeleted != statementPeriodOption.SPECIFIC_PERIOD) {
            let fromDate = getPeriodDate('START_OF_' + periodSeleted);
            let toDate = getPeriodDate('END_OF_' + periodSeleted);
            console.log("fromDate==" + fromDate + ", toDate===" + toDate);
            newParams.from_date = formatPeriodDate(fromDate);
            newParams.to_date = formatPeriodDate(toDate);
        }else{
            let fromDate = typeof from_date == 'function' ? new Date(from_date.format("DD/MM/YYYY")) : new Date(formatDateDDMMYYYY(from_date));
            let toDate = typeof to_date == 'function' ? new Date(to_date.format("DD/MM/YYYY")) : new Date(formatDateDDMMYYYY(to_date));
            console.log("fromDate===", fromDate);
            console.log("toDate===", toDate);
            newParams.from_date = formatPeriodDate(fromDate);
            newParams.to_date = formatPeriodDate(toDate);
        }
        console.log("newParams===", newParams);
        setParams(newParams);
        await onLoadAccountJournals(newParams);
        setShowLoading(false);
    }

    const onSelectPeriod = (event) => {
        setPeriodSeleted(event.target.value);
    }

    const onTopup = async (values) => {
        setShowLoading(true);
        console.log("values onToup===", values);
        if(values && values.amount && Number(values.amount) > 0){
            let hasPhone = true;
            let hasAddress = true;
            if(domainName === 'ayna' && document._portalConfig.usePaymentLocal){
                hasPhone = await onLoadPhone();
                hasAddress = await onLoadAddresses();
            }
            if (hasPhone && hasAddress) {
                try{
                    let urlPortal = window.location.origin;
                    let body = {
                        account_id: accountFinance && accountFinance.id ? accountFinance.id : null,
                        total_amount: values.amount,
                        currency: accountFinance && accountFinance.currency_code ? accountFinance.currency_code : null,
                        payment_result_url: urlPortal + paths.paygate_payment_result,
                        payment_redirect_url: document._portalConfig.urlPlugins + "/plugins",
                    };
                    let result = await crmservices.aynaottservices.initiateTopup(body);
                    console.log("result onTopup ===", result);
                    if(result.code === 'OK'){
                        if(result.data && result.data.status === 'SUCCESS'){
                            if(result.data.redirect_url) window.location.href = result.data.redirect_url;
                        }else{
                            let mess = result.data.failed_reason ? result.data.failed_reason : t('EXCEPTION_PROCESS');
                            showAlert(mess);
                        }
                    } else if (result.error && result.error.error === 'CONTACT_ADDRESS_NOT_FOUND') {
                        showAlert(t('CONTACT_ADDRESS_NOT_FOUND'));
                    } else if (result.error && result.error.error === 'CONTACT_PHONE_NOT_FOUND') {
                        showAlert(t('CONTACT_PHONE_NOT_FOUND'));
                    }else{
                        showAlert(t('EXCEPTION_PROCESS'));
                    }
                }catch(ex){
                    console.log("onToup exception ex===", ex);
                }
            }else{
                showAlert(t('CONTACT_PHONE_OR_ADDRESS_NOT_FOUND_TOPUP'))
            }
        }
        else {
            showAlert(t('amount_greater_than_0'));
        }
        setShowLoading(false);
    }

    const onLoadPhone = async () => {
        let hasPhone = false;
        try{
            var phoneResult = await crmservices.contacts.getPhones();
            console.log('MyProfile onLoadProfile phoneResult=', phoneResult)
            if (phoneResult.code === 'OK') {
                var content = phoneResult.data.content;
                if (content && content.length > 0) {
                    var phone = content.filter(p => p.is_primary);
                    if (phone && phone.length > 0) {
                        hasPhone = true;
                    }
                } else {
                    hasPhone = false;
                }
            }
        }catch(ex){
            console.log("onLoadPhone exception===", ex);
        }
        return hasPhone;
    }

    const onLoadAddresses = async () => {
        let hasAddress = false;
        try {
            var result = await crmservices.contacts.getAddresses();
            console.log('onLoadAddresses result==', result)
            if (result.code === 'OK') {
                if(result.data && result.data.content && result.data.content.length > 0){
                    hasAddress = true;
                }
            }
        } catch (error) {
            console.log('load addresses exception:', error);
        }
        return hasAddress;
    }

    console.log("paging ===", paging);
    console.log("data ===", invoices);

    return (
        <>
            <AccountAnalysisView
                currency={currency}
                open={props.open} 
                wallet={wallet}
                accountFinance={accountFinance}
                transactions={invoices}
                showLoading={showLoading}
                hasMore={hasMore}
                showLoadMore={showLoadMore}
                transactionDetail={transactionDetail}
                showTransactionDetail={showTransactionDetail}
                listPeriods={listPeriods}
                periodSeleted={periodSeleted}
                params={params}
                specificPeriod={specificPeriod}
                handleLoadMore={handleLoadMore}
                onClickDetail={onClickDetail}
                handleDrawerOtherToggle={props.onClose}
                onFilter={onFilter}
                onSelectPeriod={onSelectPeriod}
                onTopup={onTopup}
            />
            {/* {showLoading && <Loading showLoading={showLoading} />} */}
            {confirm && <ModalConfirm
                open={confirm.show}
                onClose={() => setConfirm({})}
                message={confirm.message}
                confirm={confirm.actionTitle}
            />}
            <ModalAlert
                open={error.showAlert}
                onClose={onCloseAlert}
                hideHeader={true}
                message={error.message}
            />
        </>
    );
}

function formatDateDDMMYYYY(date){
    var dateMomentObject = moment(date, "DD/MM/YYYY"); // 1st argument - string, 2nd argument - format
    var dateObject = dateMomentObject.toDate();
    return dateObject;
}
export default (withTranslation()(AccountAnalysisController));
